import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FieldOption } from './../../../models/field.interface';

@Component({
  selector: 'vfs-simple-select',
  templateUrl: './simple-select.component.html',
  styleUrls: ['./simple-select.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SimpleSelectComponent {
  @Input() options: FieldOption[];
  @Input() width: '100%';
  @Input() placeholder?: string;
  @Input() value?: any;
  @Output() changeValue = new EventEmitter<any>();

  change(event) {
    this.changeValue.emit(event.value);
  }
}
